import React, { ReactElement } from 'react';
import '../style.scss';
import './style.scss';
import { Caption } from 'views/mutual/caption';
import { QuestionCard } from 'views/mutual/questionCard';
import { NationalityQuestionBottom, NationalityQuestionTop } from './module/nationalityQuestion';
import { ResidenceQuestionBottom, ResidenceQuestionTop } from './module/residenceQuestion';
import { DateOfBirthQuestionBottom, DateOfBirthQuestionTop } from './module/dateOfBirthQuestion';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { IdentificationQuestionBottom, IdentificationQuestionTop } from './module/identificationQuestion';
import { MailAddressQuestionBottom, MailAddressQuestionTop } from './module/mailAddressQuestion';
import { SelfieQuestionBottom, SelfieQuestionTop } from './module/selfieQuestion';
import { CheckInput } from 'views/templates/module/checkInput';
import { usePersonalAccountAdvancedQuestion } from './hooks';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { TemplateProps } from '../common';

export type AdvanceQuestionProps = {
  formik: any;
  nationalityProps: any;
  countryOfResidenceProps: any;
  birthdayProps: any;
  identificationQuestionProps: any;
  mailAddressQuestionProps: any;
  selfieQuestionProps: any;
  personalInformationProps: any;
  generalTermsConditionProps: any;
  confirmResponsibilityProps: any;
};

export const AdvanceQuestionWrapper = () => {
  return <AdvanceQuestion {...usePersonalAccountAdvancedQuestion({ isUpdate: false })} />;
};

export const AdvanceQuestion = ({
  formik,
  nationalityProps,
  countryOfResidenceProps,
  birthdayProps,
  identificationQuestionProps,
  mailAddressQuestionProps,
  selfieQuestionProps,
  personalInformationProps,
  generalTermsConditionProps,
  confirmResponsibilityProps,
  isUpdate,
}: AdvanceQuestionProps & TemplateProps) => {
  const nationalityQuestionTop: ReactElement = <NationalityQuestionTop />;
  const nationalityQuestionBottom: ReactElement = <NationalityQuestionBottom {...nationalityProps} />;

  const residenceQuestionTop: ReactElement = <ResidenceQuestionTop />;
  const residenceQuestionBottom: ReactElement = <ResidenceQuestionBottom {...countryOfResidenceProps} />;

  const dateOfBirthQuestionTop: ReactElement = <DateOfBirthQuestionTop />;
  const dateOfBirthQuestionBottom: ReactElement = <DateOfBirthQuestionBottom dateProps={birthdayProps} />;  

  const identificationQuestionTop: ReactElement = <IdentificationQuestionTop {...{ isUpdate }} />;
  const identificationQuestionBottom: ReactElement = <IdentificationQuestionBottom {...identificationQuestionProps} />;

  const mailAddressQuestionTop: ReactElement = <MailAddressQuestionTop {...{ isUpdate }} />;
  const mailAddressQuestionBottom: ReactElement = <MailAddressQuestionBottom {...mailAddressQuestionProps}/>

  const selfieQuestionTop: ReactElement = <SelfieQuestionTop {...{ isUpdate }} />;
  const selfieQuestionBottom: ReactElement = <SelfieQuestionBottom {...selfieQuestionProps} />;

  useCustomLocationName('口座開設');

  return (
    <form onSubmit={formik.handleSubmit} className="personalAccountOpenTemplate">
      <div className="personalAccountOpenTemplate_description">
        <Caption label={isUpdate ? '登録情報ご変更の事前質問' : '個人口座開設お申込の事前質問'} />
      </div>
      {!isUpdate && (
        <>
          <QuestionCard
            topChildren={nationalityQuestionTop}
            bottomChildren={nationalityQuestionBottom}
            error={nationalityProps.error}
          />
          <QuestionCard
            topChildren={residenceQuestionTop}
            bottomChildren={residenceQuestionBottom}
            error={countryOfResidenceProps.error}
          />
          <QuestionCard
            topChildren={dateOfBirthQuestionTop}
            bottomChildren={dateOfBirthQuestionBottom}
            error={birthdayProps.error}
          />
          <QuestionCard
            topChildren={mailAddressQuestionTop}
            bottomChildren={mailAddressQuestionBottom}
            error={mailAddressQuestionProps.error}
          />
        </>
      )}      
      <QuestionCard
        topChildren={identificationQuestionTop}
        bottomChildren={identificationQuestionBottom}
        error={identificationQuestionProps.error}
      />
      <QuestionCard
        topChildren={selfieQuestionTop}
        bottomChildren={selfieQuestionBottom}
        error={selfieQuestionProps.error}
      />
      <div className="agreementDocument">
        <CheckInput
          name="agreement_privacy_protection"
          label={
            <>
              <a
                className="link"
                target="_blank"
                rel="noopener noreferrer"
                href={process.env.REACT_APP_PRIVACY_PROTECTION_URL}
              >
                「個人情報の保護に関する公表事項」
              </a>
              の内容を理解の上、同意します
            </>
          }
          {...personalInformationProps}
        />
        <CheckInput
          name="general_terms_condition"
          label={
            <>
              <a
                className="link"
                target="_blank"
                rel="noopener noreferrer"
                href={process.env.REACT_APP_ELECTORIC_GENERAL_TERMS_CONDITION_URL}
              >
                「FPGオンライン取引・電子署名取引一般規約」
              </a>
              第12条第9項及び第10項の個人データの第三者提供について同意します
            </>
          }
          {...generalTermsConditionProps}
        />
        <CheckInput
          name="confirm_responsibility"
          label={
            <>
              口座開設後に行う取引は、お客様をFPGに紹介した紹介者様がいる場合であっても、お客様ご自身がその責任をもって行うことに同意します
            </>
          }
          {...confirmResponsibilityProps}
        />
      </div>
      <Button
        type={ButtonType.Submit}
        label={isUpdate ? '登録情報の変更' : '口座開設の手続きを進める'}
        buttonFill={ButtonFill.black}
        buttonSize={ButtonSize.medium}
        disable={
          !formik.values.personalInformation ||
          !formik.values.generalTermsCondition ||
          !formik.values.confirmResponsibility
        }
      />
    </form>
  );
};
